// Angular modules.
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
// Third-party modules.
import { TranslateService } from '@ngx-translate/core';
import { ZkNotificationService } from '@zenklub/ng-ui';
// Zenklub interfaces.
import { IContact, IContactStatus } from 'app/interfaces/contact.interface';
import { IUserPreferences } from 'app/interfaces/userpreferences.interface';
// Zenklub services.
import { ContactsService } from 'app/services/contacts.service';
import { GlobalService } from 'app/services/global.service';
import { LocationService } from 'app/services/location.service';
import { UserService } from 'app/services/user.service';
import { enterAnimation } from 'app/utils/animations.util';
import * as $ from 'jquery';

@Component({
	selector: 'app-clientsadd',
	templateUrl: './clients-add.component.html',
	styleUrls: ['./clients-add.component.scss'],
	animations: [enterAnimation],
})
export class ClientsAddComponent implements OnInit {
	// Outputs.
	@Output() cancelAddClient: EventEmitter<any> = new EventEmitter<any>();

	// User data.
	contactData: IContact;
	userPref: IUserPreferences;
	statusList: IContactStatus[] = [];
	sessionPrice: number;

	// Status.
	isLoading = false;
	isMobile = false;
	isRedirecting = false;
	pageTitle = '';

	// Constructor.
	constructor(
		protected contact: ContactsService,
		protected global: GlobalService,
		protected location: LocationService,
		protected notifications: ZkNotificationService,
		protected router: Router,
		public translate: TranslateService,
		protected user: UserService
	) {
		this.pageTitle = this.translate.instant('PAGES.CLIENTS.ADDNEW');
	}

	// On Init.
	public ngOnInit(): void {
		// Loader.
		this.isLoading = true;

		// Verify if is a mobile device.
		this.isMobile = this.global.isMobileDevice();

		// Initialize object.
		this.resetContactData();

		// Get user preferences.
		this.userPref = this.user.getUserLocalPreferences();

		// Get status list.
		this.statusList = this.contact.getStatusList();
		this.contactData.status = this.statusList[0].key;

		// Loader.
		this.isLoading = false;
	}

	// Reset data object.
	public resetContactData(): void {
		this.contactData = {} as IContact;
	}

	// Cancel add new.
	public cancel(force = false, clientId = null): void {
		if (force || confirm(this.translate.instant('MESSAGES.AREYOUSURE'))) {
			this.resetContactData();
			this.cancelAddClient.emit(clientId);
		}
	}

	// Save new contact.
	public save(): void {
		this.isLoading = true;
		// Update contact sessionPrice if sessionPrice var has value
		if (this.sessionPrice) {
			this.contactData.sessionPrice = this.sessionPrice;
		}

		// Validate form.
		if (this.validate(this.contactData)) {
			// Try to save.
			this.contact.saveContact(this.contactData).subscribe(
				(res) => {
					// Go to list page.
					this.notifications.showSuccess(this.pageTitle);
					this.isLoading = false;
					this.cancel(true, res.id);
				},
				(error) => {
					this.isLoading = false;
					this.notifications.showError(error, this.pageTitle);
				}
			);
		} else {
			this.isLoading = false;
		}
	}

	// Validate data.
	public validate(contact: IContact): boolean {
		const errors: string[] = [];
		if (!contact.displayName) {
			errors.push(
				this.translate.instant('ERRORS.REQUIRED', {
					value: this.translate.instant('GENERAL.NAME'),
				})
			);
		}
		if (!contact.sessionPrice && contact.sessionPrice === 0) {
			errors.push(
				this.translate.instant('ERRORS.MIN_SESSIONPRICE', {
					value: this.translate.instant('GENERAL.PRICEPERSESSION'),
				})
			);
		}
		if (errors.length > 0) {
			this.notifications.showError(errors.join('<br/>'), this.pageTitle);
			return false;
		}
		return true;
	}

	// On page resize.
	public onResize(): void {
		// Verify if is a mobile device.
		this.isMobile = this.global.isMobileDevice();
		let callAgain = false;

		// Birthday.
		const inpBirthday: JQuery<HTMLElement> = $('#inpBirthday');
		if (inpBirthday && inpBirthday.length > 0) {
			inpBirthday.css('max-width', '300px');
			$('.owl-dateTime-cancel').hide();
			const faCal: JQuery<HTMLElement> = $('.iconCal');
			faCal.css('margin-top', '-32px');
			faCal.css('position', 'absolute');
			faCal.css('margin-left', inpBirthday.width());
		} else {
			callAgain = true;
		}

		if (callAgain) {
			setTimeout(() => {
				this.onResize();
			}, 100);
		}
	}

	// When price field got focus.
	public valueGotFocus(): void {
		$('.inpCurrencyField').select();
	}
}
